import React from 'react';

import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useRecordContext } from 'react-admin';
import { useFormContext } from 'react-hook-form';

import { CircularProgress } from '../../CircularProgress/CircularProgress';
import { Button, ButtonProps } from '../Button/Button';
import { hasDirtyFields } from './utils/hasDirtyFields';

export type SaveButtonProps = Omit<ButtonProps, 'type'> & {
  label?: string;
};

/**
 * Кнопка сохранения для форм react-hook-form.
 *
 * В формах редактирования (есть запись в RecordContext) кнопка неактивна,
 * пока пользователь не изменил значения.
 *
 * ⚠️ Важно: этот компонент следует использовать только **вне Toolbar**.
 * Если кнопка передается внутрь стандартного Toolbar react-admin,
 * используйте обычный <SaveButton> из react-admin.
 */
export const SaveButton: React.FC<SaveButtonProps> = ({ label, disabled, ...rest }) => {
  const translate = useTypedTranslate();
  const record = useRecordContext();

  const { formState } = useFormContext();
  const { isSubmitting, dirtyFields } = formState;

  return (
    <Button
      color="primary"
      disabled={disabled || isSubmitting || (Boolean(record) && !hasDirtyFields(dirtyFields))}
      label={label || translate('app.buttons.save')}
      startIcon={isSubmitting && <CircularProgress size={16} />}
      type="submit"
      variant="contained"
      {...rest}
    />
  );
};
